import React/*, { Component }*/ from "react";
import PropTypes from "prop-types";
import { Button } from '@progress/kendo-react-buttons';
import { isEmpty } from "../helpers";
import localize from "../hoc/localize";

class ToolbarOption extends React.Component {
    static propTypes = {
        type: PropTypes.oneOf(["add", "download-excel", "download-csv", "save", "close", "show-excluded-parts", "cancel", "clear", "close2", "add-part", "add2", "message"]).isRequired,
        handleClick: PropTypes.func,
        tooltip: PropTypes.string,
        onEditScrtooltip: PropTypes.bool,
        showExcludedParts: PropTypes.bool,
        atBottom: PropTypes.bool
    };

    getToolTip = () => {
        if (!isEmpty(this.props.tooltip)) {
            return this.props.tooltip;
        } else {
            switch (this.props.type.toLowerCase()) {
                case "add":
                    return "m0503";
                case "download-excel":
                    return "m0509";
                case "download-csv":
                    return "m0504";
                case "save":
                    return "m0252";
                case "close":
                    return "m0505";
                case "close2":
                    return "m0175";
                case "show-excluded-parts":
                    return "m0506";
                case "cancel":
                    return "m0101";
                case "clear":
                    return "m0507";
                case "add2":
                    return "m0508";
                default:
                    return "";
            }
        }

    }

    //<label className="k-checkbox-label" htmlFor="show-excluded-parts">{this.props.returnLocalizedString(this.getToolTip())}</label>
    //<input type="checkbox" id="show-excluded-parts" className="k-checkbox" onClick={this.props.handleClick} />
    render() {

        //!DBTRANS! @m0503@ Create record !DEVNOTE! Button label
        //!DBTRANS! @m0504@ Export for DMS Import !DEVNOTE! Button label
        //!DBTRANS! @m0252@ Save !DEVNOTE! Option label Button label
        //!DBTRANS! @m0505@ Close window !DEVNOTE! Button label
        //!DBTRANS! @m0175@ Close !DEVNOTE! Option label Button label
        //!DBTRANS! @m0506@ Show excluded parts !DEVNOTE!  Button label
        //!DBTRANS! @m0101@ Cancel !DEVNOTE! Option label
        //!DBTRANS! @m0507@ Reset settings !DEVNOTE!  Button label
        //!DBTRANS! @m0508@ Add !DEVNOTE! Button label
        //!DBTRANS! @m0509@ .xls Export !DEVNOTE! Button label

        let className = `option ${this.props.type}`;

        switch (this.props.type.toLowerCase()) {
            case "message":
                return (
                    <li className={className}>
                        <label>{this.getToolTip()}</label>
                    </li>
                );
            case "show-excluded-parts":
                return (
                    <li className={className}>
                        <input type="checkbox" id="show-excluded-parts" checked={this.props.showExcludedParts} className="apple-switch" onChange={this.props.handleClick} />
                        <label className="apple-switch-label" htmlFor="show-excluded-parts">{this.props.returnLocalizedString(this.getToolTip())}</label>
                    </li>
                );
            default:
                if (this.props.onEditScrtooltip)
                    return <li title={this.props.returnLocalizedString(this.getToolTip())} className={className} onClick={this.props.handleClick} />;
                else
                    //return <li title={this.props.returnLocalizedString(this.getToolTip())} className={className} onClick={this.props.handleClick} />;
                    //return <li title={this.props.returnLocalizedString(this.getToolTip())} className="k-button k-primary" onClick={this.props.handleClick}>{this.getToolTip()}</li>;
                    //return <li className={className} onClick={this.props.handleClick} >{this.props.returnLocalizedString(this.getToolTip())}</li>;
                    return <li className={className}><Button look="outline" onClick={this.props.handleClick} primary={this.props.primary} disabled={this.props.disabled} >{this.props.returnLocalizedString(this.getToolTip())}</Button></li>;
        }
    }
}
export default localize(ToolbarOption);


// WEBPACK FOOTER //
// ./src/components/ToolbarOption.js